module.exports = __webpack_public_path__ + "static/media/auth0-create-tenant-step2.eb5d0519.png";